import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

export default defineNuxtRouteMiddleware(async (to) => {
  const featureFlagsStore = useFeatureFlagsStore();

  const isMagicLinkLoginEnabled = featureFlagsStore.getByFlagName(
    featureFlagSlugs.transportMagicLinkLogin,
  );

  if (isMagicLinkLoginEnabled) {
    const hash = window?.location?.hash;
    // Remove the hash from the URL
    if (hash) {
      // If there's a cached path, we will navigate to it later, so the hash will be removed then
      if (localStorage.getItem('cachedPath')) {
        const cachedPath = JSON.parse(localStorage.getItem('cachedPath'));
        localStorage.removeItem('cachedPath');
        return navigateTo(cachedPath);
      } else {
        // Remove hash and stay on the same path is there is no chached path
        const { origin, pathname, search } = window.location;
        window.history.replaceState(null, '', origin + pathname + search);
        return navigateTo(to.path);
      }
    }
  } else {
    // if magic link login is not enabled, check for cached path and navigate
    if (localStorage.getItem('cachedPath')) {
      const cachedPath = JSON.parse(localStorage.getItem('cachedPath'));

      localStorage.removeItem('cachedPath');

      return navigateTo(cachedPath);
    }
  }
});
